module.exports = __webpack_public_path__ + "assets/LReflectionDetailed.32df527c0daceb66f373cf99b8966695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LReflectionDetailed.png
// module id = 533
// module chunks = 0